import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getShopperAgentDraftToolCalls = {
  name: "getShopperAgentDraftToolCalls" as const,
  input: z.object({ teamId: zExt.objectId(), conversationId: zExt.objectId() }),
  output: z.object({
    // The calls made while writing the current draft, in call order. Calls
    // behind earlier messages in the conversation are left out.
    toolCalls: z.array(
      z.object({
        toolName: z.string(),
        /** Set when the tool returned an error instead of a result. */
        error: z.string().optional(),
      }),
    ),
  }),
};
